import { diagnosticItems } from "@constants/mocked-data";
import { useSession } from "@features/session";
import { diagnosticTagIds } from "@helpers/session";
import type { PracticeTestExam } from "@memorang/types";
import { Audio } from "expo-av";
import { router } from "expo-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
const useDiagnostic = () => {
	const { t } = useTranslation();

	const messages = [
		t("sessionConfig.configuringSession"),
		t("sessionConfig.fetchingContent"),
		t("sessionConfig.preparingMaterials"),
		t("sessionConfig.almostThere"),
		t("sessionConfig.startingSession"),
	];
	const [selectedItemId, setSelectedItemId] = useState<number | null>(null);
	const [showPermissionDialog, setShowPermissionDialog] = useState(false);
	const { handleCreateFormativeSession, isCreatingSession } = useSession();
	const handleCreateSession = async ({
		id,
		exams,
		handleClose,
	}: {
		id: number;
		exams: PracticeTestExam[];
		handleClose?: () => void;
	}) => {
		if (diagnosticTagIds.speakingWriting === id) {
			const current = await Audio.getPermissionsAsync();
			if (current.status !== "granted") {
				const newPermission = await Audio.requestPermissionsAsync();
				if (newPermission.status !== "granted") {
					setShowPermissionDialog(true);
					return;
				}
			}
		}
		setSelectedItemId(id);
		const dist = {
			low: 0,
			high: 0,
			medium: 0,
			none: 0,
		};

		const itemIds =
			diagnosticItems.find((item) => Number(item.id) === id)?.itemIds ?? [];
		const exam = exams?.find((exam) => Number(exam.id) === id);
		handleCreateFormativeSession({
			dist,
			tags: [],
			handleClose,
			itemIds,
			additionalSessionParams: {
				title: exam?.title!,
				icon: exam?.icon!,
				sessionSubType: "DIAGNOSTIC",
				examId: exam?.id,
			},
		});
	};

	const handleViewReport = (sessionNumericId: number) => {
		router.replace({
			pathname: "/(protected)/session/[id]/report",
			params: {
				id: sessionNumericId,
			},
		});
	};

	return {
		handleCreateSession,
		handleViewReport,
		showPermissionDialog,
		isCreatingSession,
		selectedItemId,
		setShowPermissionDialog,
		messages,
	};
};

export default useDiagnostic;
